import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { darkTheme } from 'theme';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import Container from 'components/Container';
import ContentTypography from 'components/ContentTypography';
import PaddedDivider from 'components/PaddedDivider';

import PodcastIcon from 'mdi-material-ui/Podcast';

const PodcastHeaderWrapper = styled.header`
  margin: -64px 0 -32px 0;
  padding: 0 0 32px 0;
`;

const PodcastHeaderContainer = styled(Container)`
  padding-top: calc(64px + 20px);
`;

const PodcastLogo = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  height: 45px;
  min-width: 195px;
`;

const PodcastHeaderTypography = styled(ContentTypography)`
  max-width: 500px;
  margin: 0 20px;
  p > {
    margin: 0;
  }
`;

const SubscribeMenuItem = styled(MenuItem)`
  img {
    height: 40px;
    width: auto;
  }
`;

const LogoImg = styled.img`
  margin-right: 10px;
  width: auto;
  height: 45px;
`;

const PodcastHeader = ({ logo, title, header_text, subscribe_links }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <PodcastHeaderWrapper>
      <PodcastHeaderContainer>
        <Grid container alignItems="center" justify="space-between">
          <Grid item>
            <PodcastLogo to="/crispr-cuts">
              {logo && logo.url && <LogoImg src={logo.url} alt={title} />}
            </PodcastLogo>
          </Grid>
          <Hidden smDown>
            <Grid item xs>
              <PodcastHeaderTypography
                variant="body1"
                theme={darkTheme}
                dangerouslySetInnerHTML={{ __html: header_text }}
              />
            </Grid>
          </Hidden>
          <Grid item xs="auto">
            <Button
              color="primary"
              variant="contained"
              onClick={e => setAnchorEl(e.currentTarget)}
            >
              <PodcastIcon />
              &nbsp;Subscribe
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={e => setAnchorEl(null)}
              disableAutoFocusItem
            >
              {(subscribe_links || []).map((subscribe, idx) => (
                <SubscribeMenuItem
                  key={idx}
                  href={subscribe.link.href}
                  target="_blank"
                  button
                  component="a"
                >
                  {subscribe.button_image?.url ? (
                    <img
                      src={subscribe.button_image?.url}
                      alt={subscribe.link?.title || ''}
                    />
                  ) : (
                    <>{subscribe.link?.title}</>
                  )}
                </SubscribeMenuItem>
              ))}
            </Menu>
          </Grid>
        </Grid>
        <PaddedDivider spacing={1.25} />
      </PodcastHeaderContainer>
    </PodcastHeaderWrapper>
  );
};

export default PodcastHeader;
